import React from 'react';
import { Skeleton, Box, Paper, useMediaQuery, useTheme } from '@mui/material';

/**
 * Placeholder imitujący wygląd PropertyCard podczas ładowania danych.
 * Użyj zamiast spinnera, żeby uniknąć "białej ściany" przy starcie.
 */
const PropertyCardSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'stretch',
        mb: 2,
        width: '100%',
        minHeight: isMobile ? 'auto' : 140,
      }}
    >
      {/* miniatura zdjęcia */}
      <Skeleton
        variant="rectangular"
        sx={{
          width: isMobile ? '100%' : 260,
          minWidth: isMobile ? 'auto' : 260,
          height: isMobile ? 200 : 140,
          flexShrink: 0,
        }}
      />

      {/* prawa strona – tekst */}
      <Box sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        {/* tytuł */}
        <Skeleton variant="text" width="55%" height={28} />
        {/* lokalizacja */}
        <Skeleton variant="text" width="40%" height={20} />

        {/* tagi: pokoje / metraż / piętro */}
        <Box sx={{ display: 'flex', gap: 1.5, mt: 0.5 }}>
          <Skeleton variant="rounded" width={72} height={24} />
          <Skeleton variant="rounded" width={72} height={24} />
          <Skeleton variant="rounded" width={72} height={24} />
        </Box>

        {/* cena */}
        <Skeleton variant="text" width="28%" height={26} sx={{ mt: 'auto' }} />
      </Box>
    </Paper>
  );
};

export default PropertyCardSkeleton;
